import React, {useEffect, useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation, Thumbs} from 'swiper';
import 'swiper/swiper-bundle.min.css';
import styles from './HospitalCarousel.module.css';
import {useRouter} from 'next/router';
import BusinessService from '../../services/business.service';
import {getLocaleContent} from '@helper/locale-content.js';
import {changeToSlug} from '@helper/string.helper';
import Link from 'next/link';
import {safeHtml} from '@helper/sanitize-html';

SwiperCore.use([Navigation, Thumbs]);

export default function HospitalCarousel() {
    const {locale} = useRouter();
    const [businessData, setBusinessData] = useState([]);
    const [thumbsSwiper, setThumbsSwiper] = useState(null); // State for thumbnail Swiper
    const [activeIndex, setActiveIndex] = useState(0); // State for active slide index
    const [mainSwiper, setMainSwiper] = useState(null); // State for main Swiper

    useEffect(() => {
        const businessService = new BusinessService();
        businessService
            .getBusinessHome({locale})
            .then(response => {
                setBusinessData(response);
                console.log(response);
            })
            .catch(error => {
                console.error('Error fetching business data:', error);
            });
    }, [locale]);

    return (
        <div className={styles['hospital-wrapper']}>
            <div className="container">
                <div className={styles['hospital-title']}>
                    {getLocaleContent(locale, 'page.hospital.title1')}{' '}
                    <span>{getLocaleContent(locale, 'page.hospital.title2')}</span>{' '}
                    {getLocaleContent(locale, 'page.hospital.title3')}
                </div>

                <div className={styles['hospital-detail']}>
                    <div className={styles['layer1']}>
                        {/* Main Swiper */}
                        <Swiper
                            onSwiper={setMainSwiper}
                            slidesPerView={1}
                            navigation={{
                                nextEl: `.${styles['nav']} .bw_hover_prev`,
                                prevEl: `.${styles['nav']} .bw_hover_next`,
                            }}
                            thumbs={{swiper: thumbsSwiper}} // Link to thumbnail Swiper
                            onSlideChange={swiper => {
                                setActiveIndex(swiper.activeIndex);
                                console.log('Active index:', swiper.activeIndex);
                            }} // Update active index
                        >
                            {businessData.map((business, index) => (
                                <SwiperSlide key={index}>
                                    <div className={styles['hospital-featured']}>
                                        {/* <div className={styles['hospital-featured-img']}> */}
                                        <Link
                                            href={`${changeToSlug(businessData[activeIndex]?.business_name)}-m${
                                                businessData[activeIndex]?.business_id
                                            }`}>
                                            <img
                                                className={styles['hospital-featured-img']}
                                                src={business.business_image}
                                                alt={business.business_name}
                                            />
                                        </Link>
                                        {/* </div> */}

                                        <div className={styles['hospital-featured-content']}>
                                            <div>
                                                <span>{business.business_name}</span>
                                                <div>
                                                    <div />
                                                </div>
                                            </div>
                                            <p
                                                className={styles['hospital-desc']}
                                                dangerouslySetInnerHTML={safeHtml(business.description)}></p>
                                        </div>

                                        <div className={styles['hospital-address-dkkd']}>
                                            <img
                                                className={styles['address-icon']}
                                                src="/bw_image/location.svg"
                                                alt="Location Icon"
                                            />
                                            <p>
                                                <strong>{getLocaleContent(locale, 'page.hospital.address')}</strong>{' '}
                                                {business.address}
                                            </p>
                                            <img
                                                className={styles['business-license-icon']}
                                                src="/bw_image/gpdk.svg"
                                                alt="Business License Icon"
                                            />
                                            <p>{business.business_license}</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                    {/* Navigation Buttons */}
                    <div className={styles['nav']}>
                        <button className="navbtn bw_hover_next" aria-label="Prev"></button>
                        <button className="navbtn bw_hover_prev" aria-label="Next"></button>
                    </div>
                </div>

                {/* Thumbnail Swiper */}
                <div className={styles['hospital-carousel']}>
                    <Swiper
                        onSwiper={setThumbsSwiper}
                        slidesPerView={4}
                        watchSlidesProgress={true}
                        breakpoints={{
                            0: {spaceBetween: 5},
                            1024: {spaceBetween: 20},
                        }}
                        className={styles['thumbnail-swiper']}>
                        {businessData.map((business, index) => (
                            <SwiperSlide key={index}>
                                <div
                                    className={styles['hospital-card']}
                                    onClick={() => mainSwiper && mainSwiper.slideTo(index)}
                                    style={{cursor: 'pointer'}}>
                                    <img src={business.business_image} alt={business.business_name} />
                                    <div
                                        className={
                                            index === activeIndex
                                                ? styles['hospital-card-overlay-active']
                                                : styles['hospital-card-overlay']
                                        }>
                                        <h4>{business.business_name}</h4>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
